import React, { useEffect, useState } from "react";
import { LocateFixed, Check, MapPin } from "lucide-react";
import { toast } from "sonner";

export default function LocationPicker({ t, coords, onCoords }) {
  const [busy, setBusy] = useState(false);
  const locate = () => {
    if (!navigator.geolocation) { toast.error(t("loc_err")); return; }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      (p) => { onCoords({ lat: p.coords.latitude, lng: p.coords.longitude }); setBusy(false); },
      () => { setBusy(false); },
      { enableHighAccuracy: true, timeout: 15000 },
    );
  };
  useEffect(() => {
    if (!coords) locate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (coords) {
    return (
      <div data-testid="booking-location-captured" className="flex flex-wrap items-center gap-3 rounded-xl border border-[#BFE5CD] bg-[#E8F7EE] px-4 py-3 text-sm font-bold text-[#1B8A4B]">
        <Check size={18} /> {t("loc_ok")}
        <a data-testid="booking-location-map" href={`https://maps.google.com/?q=${coords.lat},${coords.lng}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline"><MapPin size={14} /> {t("loc_view")}</a>
        <button type="button" data-testid="booking-location-retry" onClick={locate} className="ml-auto text-xs underline text-[#5A5D65]">{t("loc_again")}</button>
      </div>
    );
  }
  return (
    <button type="button" data-testid="booking-use-location" onClick={locate} disabled={busy}
      className="w-full h-12 rounded-xl border-2 border-dashed border-[#E05624] bg-[#FFF1EC] text-[#E05624] font-bold text-sm inline-flex items-center justify-center gap-2 disabled:opacity-60">
      <LocateFixed size={18} /> {busy ? t("loc_busy") : t("loc_btn")}
    </button>
  );
}
